<div class="d-flex">
  <span class="me-auto text-contents">
    @if ((metadataRepresentation$ | async) === undefined) {
      <ds-loading [showMessage]="false"></ds-loading>
    }
    @if ((metadataRepresentation$ | async)) {
      <ds-metadata-representation-loader [mdRepresentation]="metadataRepresentation$ | async"></ds-metadata-representation-loader>
    }
  </span>
  <button type="button" class="btn btn-secondary"
    title="{{'form.remove' | translate}}"
    (click)="removeSelection()">
    <i class="fas fa-trash" aria-hidden="true"></i>
  </button>
</div>
